"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentResourceInferenceReportEntrySchema = void 0;
const zod_1 = require("zod");
const InferenceReportEntryBase_1 = require("./InferenceReportEntryBase");
const IComponentResource_1 = require("../FunctionalModels/IComponentResource");
exports.ComponentResourceInferenceReportEntrySchema = InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('model')
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default'))
        .or(zod_1.z.literal('hil')),
    priority: zod_1.z.number().optional(),
    resource: IComponentResource_1.IComponentResourceSchema,
});
//# sourceMappingURL=ComponentResourceInferenceReportEntry.js.map